import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export const generalMessage = (t) => t("FormValid.RequiredField");

const isNotEmpty = (value) => {
  if (typeof value === "string") {
    return value.trim() !== "";
  } else if (value instanceof File) {
    return value.size > 0; // Check if the file has content
  } else {
    return value !== null && value !== undefined; // Handle other types
  }
};

const isValidPhoneNumber = (value) => {
  if (value !== "" && value !== null) {
    return /^[0-9]\d*$/.test(value)
  } else {
    return true;
  }
}

const isValidIdFormat = (value) => {
  // const storedUsername = JSON.parse(localStorage.getItem("username"));
  // let username = "";
  // if (storedUsername.toLowerCase().includes('v')) {
  //   username = storedUsername.toLowerCase();
  // } else {
  //   username = parseInt(storedUsername, 10);
  // }
  // Check if the value is a 4-digit number
  if (/^\d{4}$/.test(value)) {
    // Convert the string to a number and check if it's within the range
    const numericValue = parseInt(value, 10);
    return numericValue >= 1 && numericValue <= 900 // && numericValue !== username;
  } else if (/^[vV]\d{4}$/.test(value)) {
    const numericValue = parseInt(value.slice(1), 10); // Remove 'v' and convert to number    
    return numericValue >= 1 && numericValue <= 100 // && value.toLowerCase() !== username;
  }
  return false;
};
const isValidEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
const isMinLength = (value) => value.length === 14;
const isValidIC = (value) => /^\d{6}-\d{2}-\d{4}$/.test(value);

const isValidCheckIn = (value) => {
  const courseData = localStorage.getItem("courseData")
    ? JSON.parse(localStorage.getItem("courseData"))
    : null;
  if (!courseData) return false;

  const checkInDate = dayjs.utc(value).format("YYYY-MM-DD");
  const startDate = dayjs.utc(courseData.start_datetime).subtract(5, 'days').format("YYYY-MM-DD");
  const endDate = dayjs.utc(courseData.start_datetime).format("YYYY-MM-DD");
  return checkInDate >= startDate && checkInDate <= endDate;
}

const isValidCheckOut = (value) => {
  const courseData = localStorage.getItem("courseData")
    ? JSON.parse(localStorage.getItem("courseData"))
    : null;
  if (!courseData) return false;

  const checkOutDate = dayjs.utc(value).format("YYYY-MM-DD");
  const startDate = dayjs.utc(courseData.end_datetime).format("YYYY-MM-DD");
  const endDate = dayjs.utc(courseData.end_datetime).add(2, 'days').format("YYYY-MM-DD");
  return checkOutDate >= startDate && checkOutDate <= endDate;
}

// Combine multiple validations
export const validate = (value, validations) => {
  for (let validation of validations) {
    if (!validation.check(value)) {
      return validation.message;
    }
  }
  return null;
};

export const infoFormValidationSchema = (t) => ({
  cname: [
    { check: isNotEmpty, message: t("FormValid.Cname") }
  ],
  ename: [
    { check: isNotEmpty, message: t("FormValid.Ename") }
  ],
  sangha_cname: [
    { check: isNotEmpty, message: t("FormValid.Sangha_cname") }
  ],
  sangha_ename: [
    { check: isNotEmpty, message: t("FormValid.Sangha_ename") }
  ],
  mobile: [
    { check: isNotEmpty, message: t("FormValid.emptyHP") },
    { check: isValidPhoneNumber, message: t("FormValid.invalidHP") }
  ],
  whatsapp: [
    { check: isValidPhoneNumber, message: t("FormValid.invalidHP") }
  ],
  email: [
    { check: isNotEmpty, message: t("FormValid.emptyEM") },
    { check: isValidEmail, message: t("FormValid.invalidEM") }
  ],
  birthdate: [
    { check: isNotEmpty, message: t("FormValid.birthDAY") },
  ],
  is_disease: [
    { check: isNotEmpty, message: generalMessage(t) }
  ],
  disease_details: [
    { check: isNotEmpty, message: t("FormValid.DiseaseField") }
  ],
  is_food_allergic: [
    { check: isNotEmpty, message: generalMessage(t) }
  ],
  food_allergic_details: [
    { check: isNotEmpty, message: t("FormValid.FoodAllergic") }
  ],
  is_medicine_allergic: [
    { check: isNotEmpty, message: generalMessage(t) }
  ],
  medicine_allergic_details: [
    { check: isNotEmpty, message: t("FormValid.MedAllergic") }
  ],
  emergency_contact_name: [
    { check: isNotEmpty, message: t("FormValid.SOScname") }
  ],
  emergency_contact_no: [
    { check: isNotEmpty, message: t("FormValid.SOScnum") },
    { check: isValidPhoneNumber, message: t("FormValid.invalidHP") }
  ],
  is_vege: [
    { check: isNotEmpty, message: generalMessage(t) }
  ],
  is_nofoodaftermidday: [
    { check: isNotEmpty, message: generalMessage(t) }
  ],
});

export const passportFormValidationSchema = (t) => ({
  passport_region: [
    { check: isNotEmpty, message: t("FormValid.Passport_Reg") }
  ],
  other_passport_region: [
    { check: isNotEmpty, message: t("FormValid.Passport_Reg") }
  ],
  ic_no: [
    { check: isValidIC, message: t("FormValid.invalidIC") },
    { check: isNotEmpty, message: t("FormValid.emptyIC") },
    { check: isMinLength, message: t("FormValid.lengthIC") },
  ],
  passport_no: [
    { check: isNotEmpty, message: t("FormValid.emptyNum") }
  ],
  passport_expired_date: [
    { check: isNotEmpty, message: t("FormValid.expiredDate") },
  ],
  passport_image: [
    { check: isNotEmpty, message: t("FormValid.imgUpload") },
  ]
});

export const loginFormValidationSchema = (t) => ({
  countryCode: [
    { check: isNotEmpty, message: t("FormValid.RequiredPhone") }
  ],
  mobile: [
    { check: isNotEmpty, message: t("FormValid.RequiredPhone") },
    { check: isValidPhoneNumber, message: t("FormValid.invalidHP") }
  ],
  student_no: [
    { check: isNotEmpty, message: t("FormValid.studentNo") },
  ],
  password: [
    { check: isNotEmpty, message: t("FormValid.RequiredPword") }
  ],
});

export const checkEligibilityFormValidationSchema = (t) => ({
  mobile: [
    { check: isNotEmpty, message: t("FormValid.RequiredPhone") },
    { check: isValidPhoneNumber, message: t("FormValid.invalidHP") }
  ],
  birthdate: [
    { check: isNotEmpty, message: t("FormValid.birthDAY") },
  ],
});

export const accomodationFormValidationSchema = (t, courseData) => ({
  room_type: [
    { check: isNotEmpty, message: t("FormValid.SetRoom") }
  ],
  is_addon_bed: [
    { check: isNotEmpty, message: generalMessage(t) }
  ],
  check_in_date: [
    { check: isNotEmpty, message: t("FormValid.SetcheckIN") },
    {
      check: isValidCheckIn,
      message: t(
        "FormValid.Must_checkin",
        {
          check_in_start: localStorage.getItem('i18nextLng') === 'en' ?
            dayjs.utc(courseData.start_datetime).subtract(5, 'days').format("D MMM") :
            dayjs.utc(courseData.start_datetime)
              .subtract(5, 'days')
              .locale("zh-cn")
              .format("M月D日"),

          check_in_end: localStorage.getItem('i18nextLng') === 'en' ?
            dayjs.utc(courseData.start_datetime).format("D MMM") :
            dayjs.utc(courseData.start_datetime)
              .locale("zh-cn")
              .format("M月D日"),

          check_in_start_day: localStorage.getItem('i18nextLng') === 'en' ?
            dayjs.utc(courseData.start_datetime).subtract(5, 'days').format("D MMM") :
            dayjs.utc(courseData.start_datetime)
              .subtract(5, 'days')
              .locale("zh-cn")
              .format("D日"),
        }
      )
    }
  ],
  check_out_date: [
    { check: isNotEmpty, message: t("FormValid.SetcheckOUT") },
    {
      check: isValidCheckOut,
      message: t(
        "FormValid.Must_checkout",
        {
          check_out_start: localStorage.getItem('i18nextLng') === 'en' ?
            dayjs.utc(courseData.end_datetime).format("D MMM") :
            dayjs.utc(courseData.end_datetime)
              .locale("zh-cn")
              .format("M月D日"),

          check_out_end: localStorage.getItem('i18nextLng') === 'en' ?
            dayjs.utc(courseData.end_datetime).add(1, 'days').format("D MMM") :
            dayjs.utc(courseData.end_datetime)
              .add(1, 'days')
              .locale("zh-cn")
              .format("M月D日"),

          check_out_end_day: localStorage.getItem('i18nextLng') === 'en' ?
            dayjs.utc(courseData.end_datetime).add(1, 'days').format("D MMM") :
            dayjs.utc(courseData.end_datetime)
              .add(1, 'days')
              .locale("zh-cn")
              .format("D日"),
        }
      )
    }
  ],
  is_roommate: [
    { check: isNotEmpty, message: generalMessage(t) }
  ],
  roommate_id: [
    { check: isNotEmpty, message: generalMessage(t) },
    { check: isValidIdFormat, message: t("FormValid.IDinvalid") }
  ],
  roommate_name: [
    { check: isNotEmpty, message: generalMessage(t) }
  ],
  roommate_relationship: [
    { check: isNotEmpty, message: generalMessage(t) }
  ],
  payment_mode: [
    { check: isNotEmpty, message: t("FormValid.SetPayment") }
  ],
  offline_payment_currency: [
    { check: isNotEmpty, message: t("FormValid.SetCurrency") }
  ],
  offline_payment_prove: [
    { check: isNotEmpty, message: t("FormValid.UploadPayment") }
  ],
});

export const tranportFormValidationSchema = (t) => ({
  is_needed_arrive_shuttle_service: [
    { check: isNotEmpty, message: generalMessage(t) }
  ],
  arrive_transport_mode: [
    { check: isNotEmpty, message: t("FormValid.TransMode") }
  ],
  arrive_datetime: [
    { check: isNotEmpty, message: t("FormValid.ARRdate") },
  ],
  arrive_airplane_no: [
    { check: isNotEmpty, message: t("FormValid.ARRflightnum") }
  ],
  arrive_terminal: [
    { check: isNotEmpty, message: t("FormValid.ARRflightterm") }
  ],
  arrive_ticket: [
    { check: isNotEmpty, message: t("FormValid.uploadTicket") }
  ],
  is_needed_depart_shuttle_service: [
    { check: isNotEmpty, message: generalMessage(t) }
  ],
  depart_transport_mode: [
    { check: isNotEmpty, message: t("FormValid.DepTrans") }
  ],
  depart_datetime: [
    { check: isNotEmpty, message: t("FormValid.DepTransDate") },
  ],
  depart_airplane_no: [
    { check: isNotEmpty, message: t("FormValid.DEPflightnum") }
  ],
  depart_terminal: [
    { check: isNotEmpty, message: t("FormValid.DEPflightterm") }
  ],
  depart_ticket: [
    { check: isNotEmpty, message: t("FormValid.DEPticket") }
  ],
});

export const interviewFormValidationSchema = (t) => ({
  is_interview: [
    { check: isNotEmpty, message: generalMessage(t) }
  ],
  first_choice: [
    { check: isNotEmpty, message: t("FormValid.one") }
  ],
  second_choice: [
    { check: isNotEmpty, message: t("FormValid.two") },
  ],
  third_choice: [
    { check: isNotEmpty, message: t("FormValid.three") }
  ],
  fourth_choice: [
    { check: isNotEmpty, message: t("FormValid.four") }
  ],
  fifth_choice: [
    { check: isNotEmpty, message: t("FormValid.five") }
  ],
  sixth_choice: [
    { check: isNotEmpty, message: t("FormValid.six") }
  ],
  seventh_choice: [
    { check: isNotEmpty, message: t("FormValid.seven") }
  ],
  eighth_choice: [
    { check: isNotEmpty, message: t("FormValid.eight") }
  ],
  ninth_choice: [
    { check: isNotEmpty, message: t("FormValid.nine") }
  ],
  tenth_choice: [
    { check: isNotEmpty, message: t("FormValid.ten") }
  ],
  first_choice_learning: [
    { check: isNotEmpty, message: t("FormValid.one") }
  ],
  second_choice_learning: [
    { check: isNotEmpty, message: t("FormValid.two") },
  ],
  third_choice_learning: [
    { check: isNotEmpty, message: t("FormValid.three") }
  ],
  fourth_choice_learning: [
    { check: isNotEmpty, message: t("FormValid.four") }
  ],
  fifth_choice_learning: [
    { check: isNotEmpty, message: t("FormValid.five") }
  ],
});

export const interviewQuestionFormValidationSchema = (t) => ({
  study_time: [
    { check: isNotEmpty, message: generalMessage(t) }
  ],
  meditation_method: [
    { check: isNotEmpty, message: generalMessage(t) }
  ],
  daily_practice_way: [
    { check: isNotEmpty, message: generalMessage(t) }
  ],
  question: [
    { check: isNotEmpty, message: generalMessage(t) }
  ],
  is_interviewed_before: [
    { check: isNotEmpty, message: generalMessage(t) }
  ],
});

export const healthDeclarationValidationSchema = (t) => ({
  is_covid: [
    { check: isNotEmpty, message: generalMessage(t) }
  ],
  is_diseases: [
    { check: isNotEmpty, message: generalMessage(t) }
  ],
  close_contact: [
    { check: isNotEmpty, message: generalMessage(t) }
  ],
  no_refund: [
    { check: isNotEmpty, message: generalMessage(t) }
  ],
  cost_incurred: [
    { check: isNotEmpty, message: generalMessage(t) }
  ],
  disturb_ajahn: [
    { check: isNotEmpty, message: generalMessage(t) }
  ],
})

export const registrationFormValidationSchema = (t) => ({
  participation_type: [
    { check: isNotEmpty, message: generalMessage(t) }
  ],
  declaration: [
    { check: isNotEmpty, message: generalMessage(t) },
    { check: (value) => value === "1", message: t("FormValid.notQualified") }
  ],
  commit_watch_video: [
    { check: isNotEmpty, message: generalMessage(t) },
    { check: (value) => value === "1", message: t("FormValid.notQualified") }
  ],
  watched_luangpu_video: [
    { check: isNotEmpty, message: generalMessage(t) },
  ],
  is_five_precepts: [
    { check: isNotEmpty, message: generalMessage(t) }
  ],
  practice_frequency: [
    { check: isNotEmpty, message: generalMessage(t) }
  ],
  participation_consent: [
    { check: isNotEmpty, message: generalMessage(t) },
    { check: (value) => value === "1", message: t("FormValid.notQualified") }
  ],
  cooperation_consent: [
    { check: isNotEmpty, message: generalMessage(t) },
    { check: (value) => value === "1", message: t("FormValid.notQualified") }
  ],
  preretreat_consent: [
    { check: isNotEmpty, message: generalMessage(t) },
    { check: (value) => value === "1", message: t("FormValid.notQualified") }
  ],
  photo_consent: [
    { check: isNotEmpty, message: generalMessage(t) },
    { check: (value) => value === "1", message: t("FormValid.notQualified") }
  ],
  accommodation_consent: [
    { check: isNotEmpty, message: generalMessage(t) },
    { check: (value) => value === "1", message: t("FormValid.notQualified") }
  ],
  attendance_consent: [
    { check: isNotEmpty, message: generalMessage(t) },
    { check: (value) => value === "1", message: t("FormValid.notQualified") }
  ],
  is_learning_with_others: [
    { check: isNotEmpty, message: generalMessage(t) }
  ],
  other_ajahn: [
    { check: isNotEmpty, message: generalMessage(t) }
  ],
  is_mental_disease: [
    { check: isNotEmpty, message: generalMessage(t) }
  ],
  mental_disease_details: [
    { check: isNotEmpty, message: t("FormValid.DiseaseField") }
  ],
  cname: [
    { check: isNotEmpty, message: t("FormValid.Cname") }
  ],
  ename: [
    { check: isNotEmpty, message: t("FormValid.Ename") }
  ],
  identity: [
    { check: isNotEmpty, message: generalMessage(t) }
  ],
  sangha_cname: [
    { check: isNotEmpty, message: t("FormValid.Sangha_cname") }
  ],
  sangha_ename: [
    { check: isNotEmpty, message: t("FormValid.Sangha_ename") }
  ],
  gender: [
    { check: isNotEmpty, message: generalMessage(t) }
  ],
  profession: [
    { check: isNotEmpty, message: generalMessage(t) }
  ],
  birthdate: [
    { check: isNotEmpty, message: t("FormValid.birthDAY") },
  ],
  passport_region: [
    { check: isNotEmpty, message: generalMessage(t) },
  ],
  other_passport_region: [
    { check: isNotEmpty, message: generalMessage(t) },
  ],
  residence_region: [
    { check: isNotEmpty, message: generalMessage(t) },
  ],
  other_residence_region: [
    { check: isNotEmpty, message: generalMessage(t) },
  ],
  province: [
    { check: isNotEmpty, message: generalMessage(t) }
  ],
  state: [
    { check: isNotEmpty, message: generalMessage(t) }
  ],
  email: [
    { check: isNotEmpty, message: t("FormValid.emptyEM") },
    { check: isValidEmail, message: t("FormValid.invalidEM") }
  ],
  mobile: [
    { check: isNotEmpty, message: t("FormValid.emptyHP") },
    { check: isValidPhoneNumber, message: t("FormValid.invalidHP") }
  ],
  preferred_social_media: [
    { check: isNotEmpty, message: generalMessage(t) },
  ],
  whatsapp: [
    { check: isNotEmpty, message: t("FormValid.emptyHP") },
    { check: isValidPhoneNumber, message: t("FormValid.invalidHP") }
  ],
  wechat_id: [
    { check: isNotEmpty, message: generalMessage(t) }
  ],
  wechat_name: [
    { check: isNotEmpty, message: generalMessage(t) }
  ],
  wechat_image: [
    { check: isNotEmpty, message: generalMessage(t) }
  ],
  line_id: [
    { check: isNotEmpty, message: generalMessage(t) }
  ],
  line_image: [
    { check: isNotEmpty, message: generalMessage(t) }
  ],
  personal_photo: [
    { check: isNotEmpty, message: generalMessage(t) }
  ],
  retreat_language: [
    { check: isNotEmpty, message: generalMessage(t) }
  ],
  interview_language: [
    { check: isNotEmpty, message: generalMessage(t) }
  ],
  pre_retreat_language: [
    { check: isNotEmpty, message: generalMessage(t) }
  ],
});